import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { FormService } from '../../../../services/form.service';
import { RequestsService } from '../../../../services/api/requests.service';
import { ValidatorService } from '../../../../services/validator.service';

import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';

@Component({
  selector: 'requests-details',
  imports: [NgbAlert, InputFieldComponent, TextAreaFieldComponent, ReactiveFormsModule],
  templateUrl: './requests-details.component.html',
  styleUrl: './requests-details.component.scss'
})
export class RequestsDetailsComponent {

  @Input() request?: any;
  @Input() readonlyRequestDetails: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };
  constructor(
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private requestsService: RequestsService
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      summary: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['request'] && changes['request'].currentValue) {
      this.form.patchValue({
        summary: this.request.summary,
        description: this.request.description,
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.request ? this.requestsService.update(this.request.requestId, values) : this.requestsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */



  getRequestSummaryInput(): FormControl { return this.getFormControl('summary');}
  getRequestDescriptionInput(): FormControl { return this.getFormControl('description');}

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
